import type { ApiZmgCacheType } from '../../../apps/api-hono/src/routes/api_zmg_public_cache/_router'
import { hc } from 'hono/client'
import { getEnvVariable } from '@lib/utils/getEnvVariable';
import { getClientRequestOptions } from './getClientRequestOptions';
import type { DeepOmitKeys } from './typeUtils';

const _client = hc<ApiZmgCacheType>('')
type FullClient = typeof _client
type GetOnlyClient = DeepOmitKeys<FullClient, '$patch' | '$delete'>
type PatchOnlyClient = DeepOmitKeys<FullClient, '$get'>

const client = hc<ApiZmgCacheType>('')
type Client = typeof client
const createZmgCacheApiClient = (...args: Parameters<typeof hc>): Client => {
    return hc<ApiZmgCacheType>(...args)
}

export const zmgAdminOnlyCacheUpdateClient: PatchOnlyClient = createZmgCacheApiClient(
    `https://${getEnvVariable('PUBLIC_API_DOMAIN')}/ZMG_PUBLIC_CACHE/`,
    getClientRequestOptions()
)

const isBrowser = typeof window !== 'undefined';
// NOT SERVERLESS FRIENDLY, but ok for now
export const zmgPublicCacheClient: GetOnlyClient = createZmgCacheApiClient(
    isBrowser ? `https://${getEnvVariable('PUBLIC_CACHE_DOMAIN_NAME')}/` : `http://127.0.0.1:8012`,
)

// const cache = new Map<string, Response>();
// const inFlightRequests = new Map<string, Promise<Response>>();

// const cachedFetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
//     const url = input.toString();
//     if (isBrowser && cache.has(url)) {
//         return cache.get(url)!.clone();
//     }

//     if (isBrowser && inFlightRequests.has(url)) {
//         const inFlightResponse = await inFlightRequests.get(url)!;
//         return inFlightResponse.clone();
//     }

//     const fetchPromise = fetch(input, init)
//         .then((response) => {
//             if (isBrowser && response.ok) {
//                 cache.set(url, response.clone());
//             }
//             return response;
//         })
//         .finally(() => {
//             if (isBrowser) {
//                 inFlightRequests.delete(url);
//             }
//         });

//     if (isBrowser) {
//         inFlightRequests.set(url, fetchPromise);
//     }

//     const response = await fetchPromise;
//     return isBrowser ? response.clone() : response;
// }
// export const zmgPublicBrowserCachedClient: GetOnlyClient = createZmgCacheApiClient(
//     `https://${getEnvVariable('PUBLIC_CACHE_DOMAIN_NAME')}/`,
//     { fetch: cachedFetch }
// )

